import React from 'react';
import './Header.scss';

const Header = (props) => (
    <header className="ghg-header">
        <h2 className="ghg-header-two">Enter Your Green Power Use</h2>
        <fieldset className="ghg-fieldset">
            <span className="ghg-details">Note, 1 MWh is equal to 1,000 kWh.</span>
        </fieldset>
        <section className="ghg-icon-container">
            <i className="fa fa-cog ghg-cog-1" aria-hidden="true"></i>
            <i className="fa fa-cog ghg-cog-2" aria-hidden="true"></i>
            <i className="fa fa-cog ghg-cog-3" aria-hidden="true"></i>
        </section>
    </header>
);

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/